import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { PureComponent } from 'react';
import { toEmojiId } from '../../util/type-helpers';
import { leftClick } from '../../util/mouse';
import { EmojiPreviewComponent } from '../common/EmojiPreviewComponent';
import { EmojiCommonProvider } from '../../context/EmojiCommonProvider';
import { typeAheadItem, selected as selectedStyles, typeAheadItemRow, typeaheadSelected } from './styles';
var EmojiTypeAheadItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(EmojiTypeAheadItem, _PureComponent);
  var _super = _createSuper(EmojiTypeAheadItem);
  function EmojiTypeAheadItem() {
    var _this;
    _classCallCheck(this, EmojiTypeAheadItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    // internal, used for callbacks
    _defineProperty(_assertThisInitialized(_this), "onEmojiSelected", function (event) {
      var _this$props = _this.props,
        emoji = _this$props.emoji,
        onSelection = _this$props.onSelection;
      if (leftClick(event) && onSelection) {
        event.preventDefault();
        onSelection(toEmojiId(emoji), emoji, event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onEmojiMenuItemMouseMove", function (event) {
      var _this$props2 = _this.props,
        emoji = _this$props2.emoji,
        onMouseMove = _this$props2.onMouseMove;
      if (onMouseMove) {
        onMouseMove(toEmojiId(emoji), emoji, event);
      }
    });
    return _this;
  }
  _createClass(EmojiTypeAheadItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        selected = _this$props3.selected,
        emoji = _this$props3.emoji,
        emojiProvider = _this$props3.emojiProvider;
      var classes = [typeAheadItem, selected && selectedStyles];
      return jsx(EmojiCommonProvider, {
        emojiProvider: emojiProvider
      }, jsx("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "ak-emoji-typeahead-item ".concat(selected ? typeaheadSelected : '')
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ,
        css: classes,
        onMouseDown: this.onEmojiSelected,
        onMouseMove: this.onEmojiMenuItemMouseMove,
        "data-emoji-id": emoji.shortName
      }, jsx("div", {
        css: typeAheadItemRow
      }, emoji && jsx(EmojiPreviewComponent, {
        emoji: emoji
      }))));
    }
  }]);
  return EmojiTypeAheadItem;
}(PureComponent);
export { EmojiTypeAheadItem as default };